import { render, staticRenderFns } from "./contentmenu.vue?vue&type=template&id=3d2c6512"
import script from "./contentmenu.vue?vue&type=script&lang=js"
export * from "./contentmenu.vue?vue&type=script&lang=js"
import style0 from "./contentmenu.vue?vue&type=style&index=0&id=3d2c6512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports